import { useTheme, Box, Typography, Stack } from '@mui/material';

export const DoubtCard = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        padding: '2rem',
        backgroundColor: `white`,
        height: 'fit-content',
        maxWidth: '100%',
        flexShrink: 1,
      }}
    >
      <Typography variant="h3">Alguma Dúvida?</Typography>
      <Typography
        variant="body2"
        sx={{ color: `${theme.palette.primary.main}` }}
      >
        Fale com a gente!
      </Typography>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={4}
        sx={{ marginTop: '1rem' }}
      >
        <Stack spacing={1}>
          <Typography
            variant="body2"
            sx={{ color: `black`, fontWeight: 'bold' }}
          >
            Horário de atendimento:
          </Typography>
          <Typography variant="body2">Segunda a sábado, 08 às 20h</Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="body2">(43) 88571-3513</Typography>
          <Typography variant="body2">adm@assegurados.com.br</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
